import * as yup from 'yup';
import translation from 'i18n/translation.json';
import { GARegisterEvent } from 'utils';
import { useAppSelector } from 'store/hooks';
import { selectUser } from 'store/slices/user';
import { AUTH_FLOWS } from 'pages/Login/utils/constants';

export const useNumberConfirmSchema = (flow?: string, isReg?: boolean) => {
  const { userInfo } = useAppSelector(selectUser);

  const isRegistration =
    userInfo?.registration_block_reason === 'need_login_to_origin_account' ? false : flow === AUTH_FLOWS.REG || isReg;
  const label = isRegistration ? 'sign_up' : 'login';
  const stage = isRegistration ? 'phone_confirmation' : 'sms_code';

  const schema = yup.object().shape({
    password: yup
      .string()
      .required(() => {
        GARegisterEvent({
          event: 'error_data',
          label,
          stage,
          field_name: 'password',
          error_text: `error_frontend: ${isRegistration ? 'Confirmation code' : 'Password'} field is required`,
          UID: userInfo.user_uuid,
        });

        return translation.errors.requiredField;
      })
      .length(4, ({ value }) => {
        if (value) {
          GARegisterEvent({
            event: 'error_data',
            label,
            stage,
            field_name: 'password',
            error_text: 'error_frontend: Code from SMS must contain 4 digits',
            UID: userInfo.user_uuid,
          });
          return translation.errors.smsCount;
        }
        return true;
      }),
    marketing_consent: yup.boolean(),
  });

  const defaultValue: yup.InferType<typeof schema> = {
    password: '',
    marketing_consent: false,
  };

  return { schema, defaultValue };
};
